import styled, { css } from 'styled-components';

export const WidgetWrapper = styled.div`
	width: 100%;
	flex: 1;
	display: flex;
	align-items: center;
	flex-direction: column;
	max-width: ${({ theme }) => theme.breakpoints.points.mobile.maxScreenWidth}px;
`;

export const BottomButtonsWrapper = styled.div<{ $isPage?: boolean }>`
	display: flex;
	justify-content: center;
	background: ${({ theme }) => theme.colors.backgrounds.main.translucent};
	border-top: ${({ theme }) => theme.border.width.medium} solid ${({ theme }) => theme.colors.borders.main.divider};

	${({ $isPage, theme }) =>
		$isPage &&
		css`
			height: ${theme.display.medium};
		`}
`;

export const BottomButtonsContent = styled.div<{ $maxWidth?: number }>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${({ theme }) => theme.spacings.small};
	max-width: ${({ $maxWidth }) => ($maxWidth ? $maxWidth + 'px' : 'none')};
	padding: ${({ theme }) => theme.spacings.xsmall} ${({ theme }) => theme.spacings.xlarge};
`;
